import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {AirbnbAuth, AirbnbCodeVerification} from '../../../../models/airbnbAuthModel';
import {PillButton} from '../../../../components/Button';

interface AirbnbCodeRequestButtonProps {
  method: AirbnbCodeVerification;
}

interface WithInjectedProps extends AirbnbCodeRequestButtonProps {
  airbnbAuth: AirbnbAuth;
}

@inject('airbnbAuth')
@observer
export default class AirbnbCodeRequestButton extends React.Component<AirbnbCodeRequestButtonProps, {}> {
  public render() {
    return (
      <PillButton onClick={this._handleRequestCode} variant="secondary">
        Request verification code
      </PillButton>
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private _handleRequestCode = () => {
    this._withInjectedProps.airbnbAuth.requestVerificationCode(this.props.method);
  };
}



// WEBPACK FOOTER //
// ./src/containers/AirbnbCodeVerificationProcedure/private/AirbnbCodeRequestButton/AirbnbCodeRequestButton.tsx